import { useFormikContext, getIn } from 'formik'

import { SignUpType, PortabilityType, SignUp } from '../../../basket/model/lines/signup.model'
import { UseSignUpType } from '../../model/line.model'

export default function useSignUpType(): UseSignUpType {
  const { values } = useFormikContext<SignUp>()

  const signUpTypes = [
    { value: SignUpType.PORTABILITY, label: 'Portabilidad' },
    { value: SignUpType.NEW_LINE, label: 'Nueva línea' },
  ]

  const portabilityTypes = [
    { value: PortabilityType.POSTPAID, label: 'Contrato' },
    { value: PortabilityType.PREPAID, label: 'Prepago' },
  ]

  const isPortability = getIn(values, 'signUpType') === SignUpType.PORTABILITY
  const isNewProduct = getIn(values, 'signUpType') === SignUpType.NEW_LINE
  const lineNumber = getIn(values, 'lineNumber')

  return { signUpTypes, portabilityTypes, isPortability, isNewProduct, lineNumber }
}
